export default "__VITE_ASSET__ByHJSnyT__"